var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPortugalFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 32,
  width: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#060",
  d: "M32 24a3.556 3.556 0 0 1-3.556 3.556H3.556A3.556 3.556 0 0 1 0 24V8a3.556 3.556 0 0 1 3.556-3.556h24.888A3.556 3.556 0 0 1 32 8v16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d52b1e",
  d: "M28.444 4.444h-15.11v23.112h15.11A3.556 3.556 0 0 0 32 24V8a3.556 3.556 0 0 0-3.556-3.556z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffcc4d",
  d: "M13.333 8.889a7.11 7.11 0 1 0 0 14.223 7.11 7.11 0 0 0 0-14.223zM7.9 12.972l1.424 1.424-2.187 1.094c.074-.909.34-1.761.763-2.518zm-.763 3.537 3.911 1.962-2.405 1.604.012.018a6.19 6.19 0 0 1-1.518-3.584zm5.307 5.642a6.173 6.173 0 0 1-2.304-.818h2.304v.818zm0-1.707H9.69l2.754-1.836v1.836zm0-2.904-.54.36-3.8-1.9 1.882-.94 2.458 2.457v.023zm0-1.28-3.149-3.149 3.15.525v2.624zm0-3.548-3.94-.634a6.207 6.207 0 0 1 3.94-2.23v2.864zm6.323.26c.422.757.689 1.61.763 2.519l-2.187-1.094 1.424-1.425zM14.222 9.85a6.21 6.21 0 0 1 3.94 2.23l-3.94.633V9.849zm0 3.787 3.15-.526-3.15 3.15v-2.624zm0 3.881 2.458-2.457 1.882.94-3.8 1.9-.54-.36v-.023zm0 4.634v-.818h2.304a6.173 6.173 0 0 1-2.304.818zm0-1.707v-1.836l2.755 1.836h-2.755zm3.79-.35.013-.02-2.405-1.603 3.91-1.962a6.2 6.2 0 0 1-1.518 3.584z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d52b1e",
  d: "M9.778 11.556v6.222a3.556 3.556 0 0 0 7.11 0v-6.222h-7.11z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.667 12.444v5.334a2.667 2.667 0 0 0 5.333 0v-5.334h-5.333z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#829acd",
  d: "M11.556 15.111h3.555v1.778h-3.555z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#829acd",
  d: "M12.444 14.222h1.778v3.556h-1.778z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M10.667 15.111h.889v1.778h-.89zm1.777 0h1.778v1.778h-1.778zm2.667 0H16v1.778h-.889zm-2.667 2.667h1.778v1.778h-1.778zm0-5.334h1.778v1.778h-1.778z"
})));
export default SvgPortugalFlag;